import { ExternalLink } from "lucide-react";
import { cn } from "@/lib/utils/general";
import { formatAddressForDisplay } from "@/lib/utils/address-utils";

interface ClickableAddressProps {
  address: string;
  displayText?: string; // Optional custom text to display (uses full address for maps link)
  className?: string;
  showIcon?: boolean;
  iconSize?: number;
  truncate?: boolean;
}

export function ClickableAddress({
  address,
  displayText,
  className,
  showIcon = true,
  iconSize = 16,
  truncate = false
}: ClickableAddressProps) {
  const handleClick = () => {
    // Encode the full address for URL safety (always use full for maps)
    const encodedAddress = encodeURIComponent(address);
    // Open Google Maps in a new tab with the address
    window.open(`https://www.google.com/maps/search/?api=1&query=${encodedAddress}`, '_blank');
  };

  // Use custom displayText if provided, otherwise format address for display (removes USA, etc.)
  const displayAddress = displayText || formatAddressForDisplay(address);

  return (
    <button
      type="button"
      onClick={handleClick}
      className={cn(
        "inline-flex items-center gap-1 text-left hover:text-primary transition-colors",
        "underline-offset-4 hover:underline focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded-sm",
        className
      )}
      title="View on Google Maps"
    >
      <span className={truncate ? "truncate" : ""}>{displayAddress}</span>
      {showIcon && (
        <ExternalLink className={cn("shrink-0 opacity-70", `h-${iconSize / 4} w-${iconSize / 4}`)} />
      )}
    </button>
  );
}